const MIN = 1;
const MAX = 9999;

const initQuantity = () => {
  document.querySelectorAll('[data-quantity]').forEach((block) => {
    const input = block.querySelector('[data-quantity-input]');
    const minus = block.querySelector('[data-quantity-minus]');
    const plus = block.querySelector('[data-quantity-plus]');
    const value = block.querySelector('[data-quantity-value]');

    if (!input) {
      return;
    }

    input.min = String(MIN);
    input.max = String(MAX);

    const syncInputWidth = () => {
      const text = input.value || String(MIN);
      input.style.width = '0';
      input.style.width = `${Math.max(text.length, 1)}ch`;
    };

    const updateButtons = () => {
      const current = Number(input.value);

      if (minus) {
        minus.disabled = current <= MIN;
      }

      if (plus) {
        plus.disabled = current >= MAX;
      }
    };

    const setValue = (nextValue, emitInput = false) => {
      const next = parseInt(nextValue, 10);
      let valueNum = isNaN(next) ? MIN : next;

      if (valueNum < MIN) {
        valueNum = MIN;
      }

      if (valueNum > MAX) {
        valueNum = MAX;
      }

      input.value = valueNum;
      updateButtons();
      syncInputWidth();

      if (emitInput) {
        input.dispatchEvent(new Event('input', {bubbles: true}));
      }
    };

    const focusToEnd = () => {
      input.focus();
      const len = input.value.length;
      input.setSelectionRange(len, len);
    };

    if (value) {
      value.addEventListener('mousedown', (evt) => {
        if (evt.target === input) {
          return;
        }

        evt.preventDefault();
        focusToEnd();
      });
    }

    input.addEventListener('focus', () => {
      requestAnimationFrame(() => {
        const len = input.value.length;
        input.setSelectionRange(len, len);
      });
    });

    if (minus) {
      minus.addEventListener('click', () => {
        setValue(Number(input.value) - 1, true);
      });
    }

    if (plus) {
      plus.addEventListener('click', () => {
        setValue(Number(input.value) + 1, true);
      });
    }

    input.addEventListener('input', () => {
      const digits = input.value.replace(/\D/g, '').slice(0, String(MAX).length);

      if (digits !== input.value) {
        input.value = digits;
      }

      if (digits && Number(digits) > MAX) {
        input.value = String(MAX);
      }

      syncInputWidth();
      updateButtons();
    });

    input.addEventListener('change', () => {
      setValue(input.value);
    });

    window.addEventListener('resize', syncInputWidth);

    setValue(input.value);
  });
};

export {initQuantity};
